import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Particles from "../Particels";

const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/reset-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, newPassword }),
        }
      );

      if (!response.ok) {
        const data = await response.json();
        setError(data.message || "Password reset failed");
        return;
      }

      setSuccess("Password reset successful! You can now log in.");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setError("An error occurred. Please try again later.");
    }
  };

  return (
    <>
      <Particles />
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="bg-white p-8 rounded-lg shadow-lg w-[350px] text-center">
          <h1 className="mb-6 text-xl font-bold">Reset Password</h1>
          {error && <p className="text-red-500 mb-4">{error}</p>}

          {success && <p className="text-green-500 mb-4">{success}</p>}

          <form onSubmit={handlePasswordReset} className="flex flex-col">
            <input
              className="mb-4 px-3 py-2 border border-gray-300 rounded"
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <input
              className="mb-4 px-3 py-2 border border-gray-300 rounded"
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button
              className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded"
              type="submit"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
